module.exports = __webpack_public_path__ + "static/img/7.baa4a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/admin/7.png
// module id = D6HF
// module chunks = 0